// @charset "utf-8"

import axios from 'axios'

const state = {
    // 回测一下
    backtestOnceData: {},
    backtestOnceParams: {},

    // 策略回测
    tradeBacktestData: {},
    tradeBacktestParams: {},

    // 收藏回测
    collectBacktestData: {},
    collectBacktestParams: {},

    // 收到的评论
    receiveDiscussData: {},
    receiveDiscussParams: {},

    // 发出的评论
    sendDiscussData: {},
    sendDiscussParams: {}
}
const mutations = {
    updateBacktestOnceData (state, data) {
        state.backtestOnceData = data
    },
    updateBacktestOnceParams (state, data) {
        state.backtestOnceParams = data
    },

    updateTradeBacktestData (state, data) {
        state.tradeBacktestData = data
    },
    updateTradeBacktestParams (state, data) {
        state.tradeBacktestParams = data
    },

    updateCollectBacktestData (state, data) {
        state.collectBacktestData = data
    },
    updateCollectBacktestParams (state, data) {
        state.collectBacktestParams = data
    },

    updateReceiveDiscussData (state, data) {
        state.receiveDiscussData = data
    },
    updateReceiveDiscussParams (state, data) {
        state.receiveDiscussParams = data
    },

    updateSendDiscussData (state, data) {
        state.sendDiscussData = data
    },
    updateSendDiscussParams (state, data) {
        state.sendDiscussParams = data
    }
}
const actions = {
    requestBacktestOnce (context, params) {
        if (params === undefined) {
            params = context.state.backtestOnceParams
        } else {
            context.commit('updateBacktestOnceParams', params)
        }
        return axios.get('/mybacktest/backtestonce', {params: params})
        .then((response) => {
            let data = response.data
            if (data.errorcode !== 0) {
                throw new Error(data.errormsg ? data.errormsg : 'request error')
            }
            return data.result
        }).then((result) => {
            context.commit('updateBacktestOnceData', result)
        })
    },

    requestTradeBacktest (context, params) {
        if (params === undefined) {
            params = context.state.tradeBacktestParams
        } else {
            context.commit('updateTradeBacktestParams', params)
        }
        return axios.get('/mybacktest/tradebacktest?order=desc&showmine=1', {params: params})
        .then((response) => {
            let data = response.data
            if (data.errorcode !== 0) {
                throw new Error(data.errormsg ? data.errormsg : 'request error')
            }
            return data.result
        }).then((result) => {
            context.commit('updateTradeBacktestData', result)
        })
    },

    requestCollectBacktest (context, params) {
        if (params === undefined) {
            params = context.state.collectBacktestParams
        } else {
            context.commit('updateCollectBacktestParams', params)
        }
        return axios.get('/mybacktest/tradebacktest?order=desc&showminecollect=1', {params: params})
        .then((response) => {
            let data = response.data
            if (data.errorcode !== 0) {
                throw new Error(data.errormsg ? data.errormsg : 'request error')
            }
            return data.result
        }).then((result) => {
            context.commit('updateCollectBacktestData', result)
        })
    },

    requestReceiveDiscuss (context, params) {
        if (params === undefined) {
            params = context.state.collectBacktestParams
        } else {
            context.commit('updateReceiveDiscussParams', params)
        }
        return axios.get('/sns/querycomment?type=in', {params: params})
        .then((response) => {
            let data = response.data
            if (data.errorcode !== 0) {
                throw new Error(data.errormsg ? data.errormsg : 'request error')
            }
            return data.result
        }).then((result) => {
            context.commit('updateReceiveDiscussData', result)
        })
    },

    requestSendDiscuss (context, params) {
        if (params === undefined) {
            params = context.state.collectBacktestParams
        } else {
            context.commit('updateSendDiscussParams', params)
        }
        return axios.get('/sns/querycomment?type=out', {params: params})
        .then((response) => {
            let data = response.data
            if (data.errorcode !== 0) {
                throw new Error(data.errormsg ? data.errormsg : 'request error')
            }
            return data.result
        }).then((result) => {
            context.commit('updateSendDiscussData', result)
        })
    }
}

const getters = {
    backtestOnceData (state) {
        return state.backtestOnceData
    },
    tradeBacktestData (state) {
        return state.tradeBacktestData
    },
    collectBacktestData (state) {
        return state.collectBacktestData
    },
    receiveDiscussData (state) {
        return state.receiveDiscussData
    },
    sendDiscussData (state) {
        return state.sendDiscussData
    }
}
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/myStrategy.js